import { Button, Input, Select } from "antd";
import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import { useAdmin } from "../../context/adminContext";
import { useEffect } from "react";

const SearchAdmin = ({
  title,
  fieldName,
  select,
  width = 200,
  noSearch = false,
  sort = true,
}) => {
  const { searchFields, setSearchFields, showFilter } = useAdmin();

  useEffect(() => {
    setSearchFields((e) => {
      return { ...e, [fieldName]: null };
    });
  }, []);
  const valueChange = (e) => {
    const currValue = e.target.value;
    setSearchFields((e) => {
      return { ...e, [fieldName]: currValue || null };
    });
  };
  const selectChange = (value) => {
    setSearchFields((e) => {
      return { ...e, [fieldName]: value || null };
    });
  };
  const sortChange = (sort) => {
    setSearchFields({ ...searchFields, sort: sort, sortField: fieldName });
  };
  return (
    <div key={fieldName}>
      <div className="titleWithSort">
        <span style={{ fontSize: 12 }}>{title}</span>
        {sort && (
          <div className="sortIcons">
            <CaretUpOutlined
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("asc")}
            />
            <CaretDownFilled
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("desc")}
            />
          </div>
        )}
      </div>
      {showFilter && (
        <>
          <div className="line" />
          {noSearch ? (
            <div style={{ height: 25 }} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {select ? (
                <Select
                  size="small"
                  value={(searchFields && searchFields[fieldName]) || null}
                  style={{ width: width }}
                  onChange={selectChange}
                >
                  {select.map((e, i) => {
                    return (
                      <Select.Option
                        style={{ width: "80%" }}
                        key={i}
                        value={e.value}
                      >
                        {e.title}
                      </Select.Option>
                    );
                  })}
                </Select>
              ) : (
                <Input
                  size="small"
                  style={{ width: "80%" }}
                  placeholder="Хайх утга"
                  value={searchFields[fieldName]}
                  onChange={valueChange}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default SearchAdmin;
